import loadable from '@loadable/component'

import { AppRoute } from 'components/components.types'
import { dropSupportOldBrowserInitialComponentData } from 'components/page/DropSupportOldBrowser/dropSupportOldBrowserInitialComponentData'
import { DropSupportOldBrowserLoadable } from 'components/page/DropSupportOldBrowser/DropSupportOldBrowserLoadable'
import { geoSeoLandingRoutes } from 'components/page/Landing/Landing.constants'
import { MainSearchSettingsLoadable } from 'components/page/MainSearchSettings/MainSearchSettingsLoadable'
import { photoRatingSettingsPath } from 'components/page/PhotoRatingSettings/PhotoRatingSettings.paths'
import { PhotoRatingSettingsLoadable } from 'components/page/PhotoRatingSettings/PhotoRatingSettingsLoadable'
import { ratingPath } from 'components/page/RatingWave/Rating.paths'
import { ratingRoute } from 'components/page/RatingWave/Rating.routes'
import { RatingSwitch } from 'components/page/RatingWave/RatingSwitch'
import {
  searchPath,
  searchSettingsPath,
} from 'components/page/Search/Search.paths'
import { SearchLoadable } from 'components/page/Search/SearchLoadable'
import { userProfileAlbumRoutes } from 'components/page/UserProfile/UserProfileAlbum/UseerProfileAlbum.routes'
import { vipTele2Path } from 'components/page/VipTele2/VipTele2.paths'
import { VipTele2Loadable } from 'components/page/VipTele2/VipTele2Loadable'
import {
  dropSupportOldBrowserPath,
  uniNoticeInlinePath,
  userProfilePath,
  userProfileSearchPath,
} from 'components/paths'
import { pwaRoutes } from 'components/routes/pwaRoutes'
import { UniNoticeInlinePageLoadable } from 'components/uninotice/UniNoticeInlineLoadable'

export const commonRoutes: AppRoute[] = [
  {
    path: vipTele2Path,
    component: VipTele2Loadable,
    exact: false,
  },
  ...pwaRoutes,
  ...ratingRoute,
  {
    path: searchSettingsPath,
    component: MainSearchSettingsLoadable,
    shouldCheck: true,
    exact: false,
  },
  {
    path: searchPath,
    component: SearchLoadable,
    shouldCheck: true,
    exact: false,
  },
  {
    path: photoRatingSettingsPath,
    component: PhotoRatingSettingsLoadable,
    shouldCheck: true,
    exact: false,
  },
  {
    path: ratingPath,
    component: RatingSwitch,
    shouldCheck: true,
    exact: false,
  },
  ...geoSeoLandingRoutes,
  {
    path: userProfileSearchPath,
    component: loadable(
      () => import('components/page/ProfileSwitch/ProfileSwitch')
    ),
    shouldCheck: true,
    exact: false,
  },
  ...userProfileAlbumRoutes,
  {
    path: userProfilePath,
    component: loadable(
      () => import('components/page/ProfileSwitch/ProfileSwitch')
    ),
    shouldCheck: true,
    exact: false,
  },
  {
    path: uniNoticeInlinePath,
    component: UniNoticeInlinePageLoadable,
    shouldCheck: true,
    exact: false,
  },
  {
    path: dropSupportOldBrowserPath,
    component: DropSupportOldBrowserLoadable,
    fetchInitialComponentData: dropSupportOldBrowserInitialComponentData,
    shouldCheck: true,
    exact: true,
  },
]
